import type { IconData } from '@stacksjs/iconify-core'

export const devicesCameraOff: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m0 1l1-1l2.5 2.5L5 1h6l2 2h3v12l-1 1zm6.765 4.765l3.97 3.97a3 3 0 0 0-3.97-3.97\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M0 3v12h12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesCameraOff
